import { RefreshCw } from 'lucide-react';
import { Button, cn } from 'twyne-new.ui';

import { useGrid } from '@/components/Grid/context';

export default function RefreshButton() {
  const { store: { loading }, handleRefresh } = useGrid()

  return <Button color='success' variant='outline' size='lg' className='max-md:p-2.5' onClick={handleRefresh} disabled={loading}>
    <div className="relative flex items-center justify-center">
      <RefreshCw size={16} className={cn('max-md:size-3.5', loading ? 'animate-spin' : '')} />
    </div>
  </Button>
}
